module.exports = {"columns":[{"label":"item","type":"string","sortable":true,"searchable":true,"mobileHidden":false},{"label":"description","type":"string","sortable":false,"searchable":true,"mobileHidden":true},{"label":"location","type":"string","sortable":true,"searchable":true,"mobileHidden":false},{"label":"price","type":"number","sortable":true,"searchable":false,"mobileHidden":false}],"defaultSortColumnIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/shops.schema.json
// module id = 194
// module chunks = 0